module.exports = __webpack_public_path__ + "static/media/blurredOrderHistory.2d47636f.svg";